import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterModule } from '@angular/router';
import { Button } from '../../../components/common/button/button';
import { AuthApiService } from '../../../services/apis/auth-api.service';
import { ApiException, ApiStatus } from '../../../services/apis/status';
import { MessageService } from '../../../services/message.service';
import { TitleService } from '../../../services/title.service';
import { validateFormGroup, validateNonEmptyString } from '../../../utils/form';

@Component({
  selector: 'app-signup-page',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatRippleModule,
    MatCheckboxModule,
    RouterModule,
    MatDividerModule,
    Button,
  ],
  templateUrl: './signup-page.html',
  styleUrl: './signup-page.scss',
})
export class SignupPage {
  formGroup: FormGroup;
  constructor(
    private titleService: TitleService,
    private fb: FormBuilder,
    private authApi: AuthApiService,
    private messageService: MessageService,
    private router: Router
  ) {
    this.titleService.setTitle('Signup');
    this.formGroup = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      fname: ['', [Validators.required, validateNonEmptyString]],
      lname: ['', [Validators.required, validateNonEmptyString]],
      password: [
        '',
        [Validators.required, Validators.pattern(`^(?=.*[A-Z]).{8,}$`)],
      ],
    });
  }

  loading = false;
  submit(e: SubmitEvent) {
    if (this.loading) {
      return;
    }
    const values = validateFormGroup(this.formGroup);
    if (!values) {
      return;
    }
    this.signup(values);
  }

  async signup(values: any) {
    try {
      this.loading = true;
      const r = await this.authApi.signup(
        values.email,
        values.fname,
        values.lname,
        values.password
      );
      if (r) {
        this.router.navigate(['/signup/sent'], {
          replaceUrl: true,
          queryParams: { email: values.email },
        });
      } else {
        this.messageService.open(
          'Failed to send email, please try again later',
          'OK'
        );
      }
    } catch (error) {
      if (error instanceof ApiException) {
        if (error.status === ApiStatus.USER_EMAIL_VERIFIED) {
          this.messageService
            .open('User email already exists', 'Login')
            ?.onAction()
            .subscribe(() => {
              this.router.navigate(['/login'], { replaceUrl: true });
            });
        } else if (error.status === ApiStatus.USER_EMAIL_SEND_TOO_FREQUENTLY) {
          this.messageService.open(
            'Email sent too frequently, please try again later',
            'OK'
          );
        } else if (error.status !== ApiStatus.OK) {
          this.messageService.open('Unknown Error', 'OK');
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
